import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import Home from './screens/Home';
import ItemDetails from './components/ItemDetails';
import Privacy from './screens/Privacy';
import Account from './screens/Account';
import Profile from './screens/Profile';
import { UserProvider } from './contexts/UserContext';

function App() {  

  return (
    <UserProvider>
      <BrowserRouter>
        <div className="App">
          <header className="App-header">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/account" element={<Account />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/item/:id" element={<ItemDetails />} />
              <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
          </header>
        </div>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;


  //   },
  //   "categoryPath": "Books & Magazines|Books",
  //   "categoryIdPath": "267|261186",
  //   "condition": "Very Good",
  //   "conditionId": "4000",
  //   "conditionDescription": "All pages clean & free of markings, edges clean.  Slipcase has some wear (see photos).",
  //   "itemLocation": {
  //     "city": "Saint Louis",
  //     "stateOrProvince": "Missouri",
  //     "postalCode": "631**",
  //     "country": "US"
  //   },
  //   "image": {
  //     "imageUrl": "https://i.ebayimg.com/images/g/0zsAAOSwFX5loXco/s-l1600.jpg",
  //     "width": 1200,
  //     "height": 1600
  //   },
  //   "itemCreationDate": "2024-01-12T17:42:40.000Z",
  //   "seller": {
  //     "username": "dinahmoes_books",
  //     "feedbackPercentage": "99.8",
  //     "feedbackScore": 734
  //   },
  //   "gtin": "3458318127",
  //   "estimatedAvailabilities": [
  //     {
  //       "deliveryOptions": [
  //         "SHIP_TO_HOME"
  //       ],
  //       "estimatedAvailabilityStatus": "IN_STOCK",
  //       "estimatedAvailableQuantity": 1,
  //       "estimatedSoldQuantity": 0,
  //       "estimatedRemainingQuantity": 1
  //     }
  //   ],
  //   "shippingOptions": [
  //     {
  //       "shippingServiceCode": "USPS Media Mail",
  //       "trademarkSymbol": "TM",
  //       "shippingCarrierCode": "USPS",
  //       "type": "Economy Shipping",
  //       "shippingCost": {
  //         "value": "5.97",
  //         "currency": "USD"
  //       },
  //       "quantityUsedForEstimate": 1,
  //       "minEstimatedDeliveryDate": "2025-07-25T10:00:00.000Z",
  //       "maxEstimatedDeliveryDate": "2025-07-31T10:00:00.000Z",
  //       "shippingCostType": "CALCULATED"
  //     }
  //   ],
  //   "returnTerms": {
  //     "returnsAccepted": true,
  //     "refundMethod": "MONEY_BACK",
  //     "returnShippingCostPayer": "BUYER",
  //     "returnPeriod": {
  //       "value": 30,
  //       "unit": "CALENDAR_DAY"
  //     }
  //   },
  //   "localizedAspects": [
  //     {
  //       "type": "STRING",
  //       "name": "Publication Year",
  //       "value": "1979"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Format",
  //       "value": "Paperback"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Language",
  //       "value": "German"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Book Title",
  //       "value": "Kinder und Hausmärchen"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Author",
  //       "value": "Brothers Grimm"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Features",
  //       "value": "Illustrated"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Publisher",
  //       "value": "Insel Verlag"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "Original Language",
  //       "value": "German"
  //     },
  //     {
  //       "type": "STRING",
  //       "name": "ISBN",
  //       "value": "3458318127"
  //     }
  //   ],
  //   "topRatedBuyingExperience": false,
  //   "buyingOptions": [
  //     "FIXED_PRICE",
  //     "BEST_OFFER"
  //   ],
  //   "itemWebUrl": "https://www.ebay.com/itm/386623580956",
  //   "description": "A beautifully illustrated (by Otto Ubbelohde) collection of the Brothers Grimm fairy tales, in the original German.&nbsp; Three volumes in publisher's slip case.&nbsp;&nbsp;",
  //   "paymentMethods": [
  //     {
  //       "paymentMethodType": "OTHER"
  //     },
  //     {
  //       "paymentMethodType": "WALLET",
  //       "paymentMethodBrands": [
  //         {
  //           "paymentMethodBrandType": "PAYPAL"
  //         },
  //         {
  //           "paymentMethodBrandType": "APPLE_PAY"
  //         },
  //         {
  //           "paymentMethodBrandType": "GOOGLE_PAY"
  //         }
  //       ]
  //     },
  //     {
  //       "paymentMethodType": "CREDIT_CARD",
  //       "paymentMethodBrands": [
  //         {
  //           "paymentMethodBrandType": "VISA"
  //         },
  //         {
  //           "paymentMethodBrandType": "MASTERCARD"
  //         },
  //         {
  //           "paymentMethodBrandType": "DISCOVER"
  //         },
  //         {
  //           "paymentMethodBrandType": "DINERS_CLUB"
  //         }
  //       ]
  //     }
  //   ],
  //   "immediatePay": true,
  //   "enabledForGuestCheckout": true,
  //   "eligibleForInlineCheckout": true,
  //   "lotSize": 0,
  //   "legacyItemId": "386623580956",
  //   "priorityListing": false,
  //   "adultOnly": false,